import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';
import { PrivateRoute } from '../components';
import Forms from './Forms';
import ViewForm from './forms/ViewForm';
import EditForm from './forms/EditForm';
import NewForm from './forms/NewForm';

const propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }).isRequired,
};

function FormsRouter({ match }) {
  return (
    <Switch>
      <PrivateRoute exact path={match.path} component={Forms} />
      <PrivateRoute exact path={`${match.path}/new`} component={NewForm} />
      <Route exact path={`${match.path}/:formId`} component={ViewForm} />
      <PrivateRoute path={`${match.path}/:formId/edit`} component={EditForm} />
    </Switch>
  );
}

FormsRouter.propTypes = propTypes;
export default FormsRouter;
